var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#596266",
    d: "M8,2.00264511 C11.3137085,2.00264511 14,4.69095368 14,8.00715037 C14,9.66261901 13.3305556,11.1616131 12.2478037,12.2478037 L10.8304998,10.8304998 C11.5531393,10.1068067 12,9.10766171 12,8.00414686 C12,5.79500786 10.209139,4.00414686 8,4.00414686 L8,5.50375438 L5,3 L8,0.5 L8,2.00264511 Z M8,13.9944399 C4.6862915,13.9944399 2,11.3061314 2,7.98993466 C2,6.33446603 2.66944437,4.8354719 3.75219635,3.74928138 L5.1695002,5.16658523 C4.4468607,5.89027838 4,6.88942332 4,7.99293817 C4,10.2020772 5.790861,11.9929382 8,11.9929382 L8,10.4933306 L11,12.997085 L8,15.497085 L8,13.9944399 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/Update.29b7a3a3.svg";
export { ForwardRef as ReactComponent };